/* eslint-disable import/no-duplicates */
import { format, parse } from 'date-fns';
import { ja } from 'date-fns/locale';
// 日本語用の設定値
const locale = { locale: ja };
/**
 * date-fnsのラッパー関数：フォーマット関連
 */
// デフォルトの日付フォーマット
export const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';
/**
 * 日付が不正（Invalid Date）かどうかを判定する
 * @param date
 */
export const isInvalidDate = (date) => Number.isNaN(date.getTime());
/**
 * 値をDateオブジェクトにして返す
 * @param args
 */
export const formatToDate = (args) => {
    const { formatString: _formatString, options = {}, value } = args;
    const formatString = _formatString || DEFAULT_DATE_FORMAT;
    if (value === '') {
        // 空文字の場合
        return null;
    }
    if (value instanceof Date) {
        // Dateオブジェクトだった場合は引数をそのまま返す
        return value;
    }
    if (typeof value === 'number') {
        // 数値の場合はキャストして返す
        return new Date(value);
    }
    // 指定されたformatでparseを実行
    const date = parse(value, formatString, new Date(), Object.assign(Object.assign({}, locale), options));
    return isInvalidDate(date) ? null : date;
};
/**
 * 日付を文字列としてフォーマットして返す
 * @param args
 */
export const formatToString = (args) => {
    const { formatString: _formatString, options = {}, value } = args;
    const formatString = _formatString || DEFAULT_DATE_FORMAT;
    if (value === '') {
        // 空文字の場合
        return '';
    }
    // 値がDateオブジェクト以外だった場合はparseしておく
    const date = value instanceof Date ? value : new Date(value);
    return isInvalidDate(date)
        ? ''
        : format(date, formatString, Object.assign(Object.assign({}, locale), options));
};
